
import { throwError as observableThrowError, Observable, of } from 'rxjs';
import { catchError, refCount, publishReplay, map } from 'rxjs/operators';
import { Injectable, EventEmitter, Output } from '@angular/core'
//import { Headers} from '@angular/http' //Http,
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Router } from '@angular/router'
import { UserModel } from '../insa-models/user.model';
import { SharedMethodsModule } from '../insa-custom-scripts/sharedMethods';
import { appConfig } from '../../insaweb.config';
import { JwtHelper } from './ng2_jwt';
import { RegistrationFields } from '../insa-models';


@Injectable()
export class AuthService {
  private hostAddress = appConfig.authServiceAddress;
  private servicesURL = "/api/Account";
  private loggedIn: boolean = false;
  private loaded: boolean = false;
  private expires: number;
  roles: string;
  auth_token: string;
  sessionId: string;
  UserInfo: UserModel;
  changeSucceeded: boolean = false;
  passChangeMessage: string;
  registrationSucceeded: boolean = false
  embeddedToken: boolean = false;
  jwtHelper: JwtHelper = new JwtHelper();

  @Output() LoggedInStatusChangedEmitter = new EventEmitter();
  @Output() UserInfoEmitter = new EventEmitter();
  @Output() registrationSuccessEmitter = new EventEmitter();
  @Output() activationSuccessEmitter = new EventEmitter();

  constructor(private http: HttpClient, private _router: Router) {
    let tempToken: string = localStorage.getItem('accessToken');
    this.loggedIn = false;
    if (tempToken) {
      this.performAuthenticaton(tempToken);
      this.getUserInfo(true, true);
    }
  }

  login(username, password, jwt = '') {
    let headers = this.getAuthHeaders('application/x-www-form-­urlencoded');
    let jwtquery = '';
    if (jwt != '') {
      jwtquery = '&jwt=' + encodeURIComponent(jwt);
    }
    else {
      jwtquery = '';
    }


    this.http.post(this.hostAddress + '/Login', 'grant_type=password&username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password) + jwtquery,
      { headers }).pipe(publishReplay(), refCount(),
        catchError(err => this.handleError(err, "Could not log in. Please check username and/or password!")))
      .pipe(map((res: any) => {
        // res.username === username
        if (res) {
          console.log(res);
          this.roles = res.Roles;
          this.performAuthenticaton(res.access_token);
          this.emitLogedInStatusChange();
        }

        return;
      })).subscribe();
  }


  performAuthenticaton(token: string) {
    this.loggedIn = !this.jwtHelper.isTokenExpired(token);
    //this.loggedIn = (token !== "");
    if (this.loggedIn) {
      var decoded = this.jwtHelper.decodeToken(token);
      this.auth_token = token;
      this.sessionId = decoded.SessionID;
      this.embeddedToken = (decoded.embeddedToken ? true : false);
      this.expires = (this.jwtHelper.getTokenExpirationDate(token).valueOf() - new Date().valueOf()) / 1000;
      setTimeout(this.logout.bind(this), this.expires * 1000);
      localStorage.setItem('accessToken', this.auth_token);
      localStorage.setItem('sessionid', this.sessionId);
    } else {
      this.logout();
    }
  }
  // This function is used to allow login from within WPF embedded browser.
  // Function should be called only within 1 specific route only WPF uses
  // That route is navigate by WPF after the embedded browser is initialized
  // We set a non-expiring token in this case :)
  embeddedLogin(access_token) {
    console.log('Embedded Login initialized')
    console.log('Logging in user...');
    // token valid, login user
    this.performAuthenticaton(access_token);
    this.sessionId = 'INSA_EMBEDDED';
    this.expires = 60 * 60 * 24 * 30; // expire in 30 days, this should be enough
    this.roles = undefined; // GetUserInfo will fill it in!
    localStorage.setItem('sessionid', this.sessionId);
    this.getUserInfo(true, true);
    return true;
  }

  changePassword(username, password, newPassword) {
    let headers = this.getAuthHeaders('application/x-www-form-­urlencoded');

    this.http.post(this.hostAddress + this.servicesURL + '/ChangePassword?userName=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password) + '&newPassword=' + encodeURIComponent(newPassword),
      { headers }).pipe(publishReplay(), refCount(),
        catchError(err => this.handleError(err, "Could not change password. Please check old username and/or password!")),
        map((res) => {
          //  this.changeSucceeded = res.ChangeSucceeded
          if (this.changeSucceeded) {
            this.loggedIn = false;
            //  this.passChangeMessage = res.Message;
            this.emitLogedInStatusChange();
          } else {
            console.log("Error occured!")
          }
        })).subscribe();
  }

  register(fields: RegistrationFields) {
    setTimeout(() => {
      this.registrationSuccessEmitter.emit(true)
    }, 2000)
  }

  verifyActivationCode(activationCode: string) {
    setTimeout(() => {
      this.activationSuccessEmitter.emit(true)
    }, 2000)
  }

  getUserInfo(doEmitLoginChange = false, preventRedirect = false) {
    let headers = this.getAuthHeaders('application/json');
    let timeStamp = +new Date();

    let req = this.http.get(
      this.hostAddress + this.servicesURL + '/UserInfo' + '?tsp=' + timeStamp,
      { headers }).pipe(publishReplay(), refCount(),
        catchError(err => this.handleError(err, "Could not get user info ")))
    req.subscribe((data: UserModel) => {
      this.UserInfo = data;
      if (this.roles === undefined) {
        // TODO: sort the roles or something?
        this.roles = this.UserInfo.Roles.find(() => true);
      }
      this.UserInfoEmitter.emit(this.UserInfo);
      // emit login change for embedded login scenario
      if (doEmitLoginChange) {
        this.loggedIn = true;
        this.emitLogedInStatusChange(preventRedirect, this.embeddedToken);
      }
    }, this.handleError.bind(this));
    return req;
  }

  logout() {
    this.auth_token = "";
    this.sessionId = "";
    this.loggedIn = false;
    localStorage.removeItem('accessToken');
    localStorage.removeItem('sessionid');
    this.emitLogedInStatusChange();
  }

  isLoggedIn() {
    return this.loggedIn;
  }

  private emitLogedInStatusChange(preventRedirect = false, embeddedMode = false) {
    this.LoggedInStatusChangedEmitter.emit({ value: this.loggedIn, preventRedirect: preventRedirect, embeddedMode: embeddedMode });
  }

  getAuthHeaders(contentType: string): HttpHeaders {
    let headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this.auth_token)
      .set('Access-Control-Allow-Headers', 'Authorization')
      .set('Content-Type', contentType);
    //.set('Accept', contentType)

    /*headers.append('Authorization', 'Bearer ' + this.auth_token);
    headers.append('Access-Control-Allow-Headers', 'Authorization');
    headers.append('Content-Type', contentType + 'charset=utf-8');
    //headers.append('Accept', contentType);*/
    return headers;
  }

  public handleError(error: any, message: string) {
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg);
    kendo.ui.progress($(".main-loading"), false);
    SharedMethodsModule.addNotification("#notification", message, false);
    this._router.navigate(['/login']);
    return observableThrowError(errMsg);

  }

  public loadDefaultGridLayout(gridName: string, metadataName) {
    const key = metadataName ? `${gridName}/${metadataName}/defaultLayout` : `${gridName}/defaultLayout`
    const defaultLayout = JSON.parse(localStorage.getItem(key))
    return of(defaultLayout || { name: 'default' });
  }

  public saveDefaultGridLayout(gridName: string, metadataName: string, gridOptions: kendo.ui.GridOptions) {
    const key = metadataName ? `${gridName}/${metadataName}/defaultLayout` : `${gridName}/defaultLayout`
    const options = { name: 'default', options: gridOptions };
    localStorage.setItem(key, JSON.stringify(options))
  }

}


// WEBPACK FOOTER //
// ./app/insa-services/auth.service.ts